// Location Tracking — Phase 4. Driver-location fetchers.
//
// `latest` returns the most recent known position per driver (polled by
// the live map). `history` returns one driver's positions for a single
// day. Both return the unwrapped `data` payload of the standard envelope.

import { apiClient } from './client';
import { endpoints } from './endpoints';

export interface DriverLocationDto {
  enc_id: string;
  driver_name: string;
  latitude: number;
  longitude: number;
  accuracy_m: number | null;
  speed_mps: number | null;
  heading_deg: number | null;
  recorded_at: string;
}

export interface StaffLocationDto {
  enc_id: string;
  staff_name: string;
  latitude: number;
  longitude: number;
  accuracy_m: number | null;
  speed_mps: number | null;
  heading_deg: number | null;
  recorded_at: string;
}

export type MapLocationEntry =
  | ({ type: 'driver' } & DriverLocationDto)
  | ({ type: 'staff' } & StaffLocationDto);

export interface LatestLocationsResponse {
  locations: DriverLocationDto[];
}

export interface LatestStaffLocationsResponse {
  locations: StaffLocationDto[];
}

export interface LocationHistoryResponse {
  history: DriverLocationDto[];
}

export async function fetchLatestDriverLocations(): Promise<LatestLocationsResponse> {
  const res = await apiClient.get<LatestLocationsResponse>(
    endpoints.driverLocations.latest,
  );
  return res.data;
}

export async function fetchLatestStaffLocations(): Promise<LatestStaffLocationsResponse> {
  const res = await apiClient.get<LatestStaffLocationsResponse>(
    endpoints.staffLocations.latest,
  );
  return res.data;
}

export async function fetchDriverLocationHistory(
  encDriverId: string,
  date: string,
): Promise<LocationHistoryResponse> {
  const res = await apiClient.get<LocationHistoryResponse>(
    endpoints.driverLocations.history(encDriverId),
    { params: { date } },
  );
  return res.data;
}
